import React from 'react';
import { ShoppingCart, ChevronLeft } from 'lucide-react';
import { isStoreClosed } from './StoreClosedBanner';

/**
 * Floating "open cart" button shown when the cart has items and no
 * higher-priority modal is open. Hides itself if the store is closed.
 */
export function StoreFloatingCart({
    store,
    cart,
    showCart,
    selectedProduct,
    onOpenCart,
    getTotalItems,
    getTotalPrice,
}) {
    if (isStoreClosed(store) || cart.length === 0 || showCart || selectedProduct) {
        return null;
    }

    return (
        <div className="fixed bottom-24 sm:bottom-20 lg:bottom-28 left-0 right-0 z-floating flex justify-center animate-fade-in px-4 pointer-events-none">
            <button
                type="button"
                onClick={onOpenCart}
                aria-label="פתח סל קניות"
                className="pointer-events-auto w-full max-w-md bg-success-500 hover:bg-success-600 text-ink-inverse font-bold py-4 px-6 rounded-xl shadow-elevated flex items-center justify-between transition-[background-color,box-shadow] duration-200 ease-smooth"
            >
                <div className="flex items-center gap-3">
                    <ShoppingCart className="w-6 h-6" />
                    <span className="text-lg">סל קניות</span>
                    <span className="bg-white/20 px-3 py-1 rounded-pill text-sm">
                        {getTotalItems()} פריטים
                    </span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-xl">₪{getTotalPrice().toFixed(2)}</span>
                    <ChevronLeft className="w-5 h-5" />
                </div>
            </button>
        </div>
    );
}

export default StoreFloatingCart;
